import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addCategory({ dispatch, commit }, category) {
    try {
      const { data } = await request.post('categories', category);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
